import { getRougeYardline } from "../../utils/context-utils";
import DefaultValue from "./default-value";

export default class RougeYardlineDefaultValue extends DefaultValue {
    constructor(play, fragment, summaryContext) {
        super(play, fragment, summaryContext);
    }

    resolve() {
        const { homeTeamHasPossession, gameConfig } = this.summaryContext;
        return getRougeYardline(!homeTeamHasPossession, gameConfig);
    }
}
